import styled from 'styled-components';
import {
  size,
  Col,
} from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';

export const StyledSectionWrapper = styled(SectionWrapper)`
  padding: ${size.xl2}px 0 ${size.xl4}px 0;
`;

export const ResourceListFilterCol = styled(Col)`
  padding-bottom: ${size.xl4}px;
`;
